<ul></ul><div class="clearfix"></div>